import { RemoveRedEye } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  InputProps,
  Typography,
} from "@mui/material";

import toString from "lodash/toString";

import React, { useState } from "react";

type StyledTextFieldProps = {
  validationErrorMessage?: string;
  label?: string;
  onChange: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
};

export const StyledTextField = (props: StyledTextFieldProps & InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <FormControl
      fullWidth
      required={props.required}
      error={!!(props.validationErrorMessage && props.validationErrorMessage?.length > 1)}
    >
      {props.label && (
        <FormLabel>
          <Typography variant="overline">{props.label}</Typography>
        </FormLabel>
      )}
      <Input
        sx={props.sx}
        color={props.color}
        fullWidth
        disabled={props.disabled}
        onKeyDown={(val) => {
          if (val.code === "Enter") {
            val.stopPropagation();
          }
          props.onKeyDown?.(val);
        }}
        disableUnderline
        multiline={!!(props.multiline ?? props.minRows)}
        minRows={props.minRows ? props.minRows : 1}
        required={props.required}
        value={props.value}
        placeholder={props.placeholder ?? ""}
        name={props.name}
        inputRef={props.inputRef}
        type={showPassword ? "text" : props.type}
        onClick={(e) => {
          e.stopPropagation();
        }}
        startAdornment={props.startAdornment ? props.startAdornment : undefined}
        endAdornment={
          props.type === "password" ? (
            <RemoveRedEye
              onClick={(e) => {
                e.stopPropagation();
                setShowPassword((prev) => !prev);
              }}
            />
          ) : props.endAdornment ?? undefined
        }
        onChange={(e) => {
          e.stopPropagation();
          props.onChange(e);
        }}
      />
      {props.validationErrorMessage &&
      props.validationErrorMessage.length > 1 &&
      toString(props.value).length > 0 ? (
        <FormHelperText variant="standard">
          {props.validationErrorMessage}
        </FormHelperText>
      ) : (
        <></>
      )}
    </FormControl>
  );
};
